import { render } from "@/components/pages/realWorldData/realWorldDataVsoc/RealWorldDataVsoc.html?vue&type=template&id=388d044b&external"
import script from "@/components/pages/realWorldData/realWorldDataVsoc/RealWorldDataVsoc.js?vue&type=script&lang=js&external"
export * from "@/components/pages/realWorldData/realWorldDataVsoc/RealWorldDataVsoc.js?vue&type=script&lang=js&external"

import "@/components/pages/realWorldData/realWorldDataVsoc/RealWorldDataVsoc.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__